import moment from 'moment-timezone';
import { XMPP } from "../helpers/xmpp-client";
// import { XMPPClient } from "../helpers/xmpp-client";
import config from "../constants/config";
import { getContactList, uploadFile, pushBulkMessages } from "../actions/chat";
// import { pushMessage, connectedXMPP } from "../actions/chat";
import {
    CONNECT_XMPP, SEND_MESSAGE_TO_XMPP, CONNECTED_XMPP, FILE_UPLOADING,
    DISCONNECT_XMPP, LOGOUT, CHAT_CONTACT_LIST, FILE_UPLOADED_ON_SUCCESS
} from "../constants/action-types";
import { FILE_STORAGE_GOOGLE } from "../constants";

const xmppMiddleware = store => {
    let xmppClient = null;
    let isLive = false, bulkMessages = [], lastReceivedAt = null;

    const xmppConnect = (action) => {
        if (!config.chat.SERVER_URL || !config.chat.IS_ENABLE) return action;

        const contactId = `fm_${action.loginId}`;
        const farmId = action.farmId;
        action = { ...action, contactId, farmId };
        // xmppClient = new XMPPClient(config.chat.SERVER_URL, config.chat.DOMAIN);
        // xmppClient.onConnecting(() => XMPP.logger('XMPP is connecting...'));
        // xmppClient.onConnectFailed(() => XMPP.logger('XMPP failed to connect.'));
        // xmppClient.onAuthFailed(() => XMPP.logger('XMPP authentication failed.'));
        // xmppClient.onDisconnecting(() => XMPP.logger('XMPP is disconnecting...'));
        // xmppClient.onDisconnected(() => XMPP.logger('XMPP is disconnected.'));
        // xmppClient.onConnected(() => {
        //     XMPP.logger('XMPP is connected.');
        //     store.dispatch(connectedXMPP());
        // });

        // xmppClient.connect(xmppClient.getIdToJid(contactId), contactId);
        return action;
    }

    // Commenting onMessage because of console warning while commenting xmppClient.onMessage(onMessage);

    // const onMessage = (message, raw) => {
    //     if (message.body && isValidateBody(message.body)) {
    //         const buildMessage = messageBuilder({
    //             from: message.fromId, to: message.toId, chatType: message.chatType,
    //             messageType: message.messageType, authorId: message.authorId, body: message.body
    //         });

    //         if (isLive) store.dispatch(pushMessage(buildMessage));
    //         else {
    //             isLive = false;
    //             lastReceivedAt = new Date().getTime();
    //             bulkMessages.push(buildMessage);
    //         }
    //     } else logger(raw);
    //     return true;
    // }

    const bulkMessageTimer = () => {
        const timerId = setInterval(() => {
            if (bulkMessages.length > 0 && lastReceivedAt > 0 && !isLive) {
                const diffSeconds = Math.floor(((new Date().getTime() - lastReceivedAt) / 1000) % 60);
                if (diffSeconds >= 3) {
                    isLive = true;
                    clearInterval(timerId);
                    store.dispatch(pushBulkMessages(bulkMessages));
                }
            }
        }, 1000);
    }

    const xmppConnected = () => {
        bulkMessageTimer();
        xmppClient.setPresence();
        // xmppClient.onMessage(onMessage);

        xmppClient.onPresence(presence => {
            XMPP.logger(presence);
        });

        xmppClient.onSubscription(stanza => {
            XMPP.logger(stanza);
        });

        //get contact list
        store.dispatch(getContactList(store.getState().chat.profile.farmId));
    }

    // Commenting logger and isValidateBody because of console warning while commenting xmppClient.onMessage(onMessage);

    // const logger = message => {
    //     // XMPP.logger("Unknown message :=>");
    //     // XMPP.logger(message);
    //     return true;
    // }

    // const isValidateBody = body => {
    //     return (body.hasOwnProperty("id") && body.hasOwnProperty("ts")
    //         && body.hasOwnProperty("contentType") && body.hasOwnProperty("content"));
    // }

    const joinIntoContact = contactList => {
        const chat = store.getState().chat;
        if (!chat.profile.contactId) return;
        if (!Array.isArray(contactList)) return;

        if (chat.contactList.length > 0) {
            const { added, removed } = compareContactList(chat.contactList, contactList);

            const idWiseContactList = {};
            chat.contactList.forEach(item => idWiseContactList[item.contact_id] = item);

            removed.forEach(e => {
                xmppClient.leave(
                    xmppClient.getIdToJid(e.contact_id, (e.chat_type !== "single")),
                    xmppClient.getIdToJid(chat.profile.contactId));
                if (idWiseContactList[e.contact_id]) delete idWiseContactList[e.contact_id];
            });

            added.forEach(e => {
                xmppClient.join(
                    xmppClient.getIdToJid(e.contact_id, (e.chat_type !== "single")),
                    xmppClient.getIdToJid(chat.profile.contactId));
                if (!idWiseContactList[e.contact_id]) idWiseContactList[e.contact_id] = e;
            });

            return Object.keys(idWiseContactList).map(id => idWiseContactList[id]);
        } else {
            contactList.forEach(e => {
                xmppClient.join(
                    xmppClient.getIdToJid(e.contact_id, (e.chat_type !== "single")),
                    xmppClient.getIdToJid(chat.profile.contactId));
            });
            return contactList;
        }
    }

    const compareContactList = (list1, list2) => {
        const added = [], removed = [];

        for (const item of list2) {
            const find = list1.filter(e => e.contact_id === item.contact_id);
            if (find.length === 0) added.push(item);
        }

        for (const item of list1) {
            const find = list2.filter(e => e.contact_id === item.contact_id);
            if (find.length === 0) removed.push(item);
        }

        return { added, removed };
    }

    const sendMessage = action => {
        const message = action.message;
        const messageId = XMPP.uuid();
        message.body["id"] = messageId;

        if (message.body.attachments && message.body.attachments.length > 0) {
            const unixTime = moment.utc().valueOf();
            const attachments = message.body.attachments.map((e, i) => ({
                id: (unixTime + i), storage: FILE_STORAGE_GOOGLE,
                file: e.file, name: e.file.name, type: e.file.type
            }));

            message.body.attachments = attachments.map(e => ({
                id: e.id, url: null, name: e.name, type: e.type, state: 0, percent: 0,
                ...e.file.type.indexOf("image") >= 0 ? { file: e.file } : {}
            }));

            store.dispatch(uploadFile(message.to, messageId, attachments));
        } else {
            const chat = store.getState().chat;
            const findItems = chat.contactList.filter(e => e.contact_id === message.to);
            const chatType = (findItems.length > 0) ? findItems[0].chat_type : null;

            xmppClient.sendMessage(messageBuilder({
                from: xmppClient.getIdToJid(chat.profile.contactId),
                to: xmppClient.getIdToJid(message.to, (chatType !== "single")),
                chatType, body: message.body
            }));
        }

        return { ...action, message: { ...message, messageType: 1 } };
    }

    const fileUploading = action => {
        const contactId = action.to;
        const chat = store.getState().chat;
        if (!chat.messageHistory[contactId]) return;

        const messages = chat.messageHistory[contactId].filter(e => e.id === action.messageId && Array.isArray(e.attachments));
        if (messages.length === 0) return;

        const body = messages[0];
        for (const item of body.attachments) {
            if (item.id !== action.attachmentId) continue;
            if (item.hasOwnProperty("file")) delete item.file;
            item.state = 0;
            item.percent = action.uploadPercent;
            item.size = action.size;
            break;
        }

        return { ...action, contactId, body };
    }

    const fileUploaded = action => {
        const contactId = action.to;
        const chat = store.getState().chat;
        if (!chat.messageHistory[contactId]) return;

        const messages = chat.messageHistory[contactId].filter(e => e.id === action.messageId && Array.isArray(e.attachments));
        if (messages.length === 0) return;

        const body = messages[0];
        for (const item of body.attachments) {
            if (item.id !== action.attachmentId) continue;
            if (item.hasOwnProperty("file")) delete item.file;
            if (action.duration) item.duration = action.duration;
            item.url = action.url;
            item.state = 1;
            break;
        }

        const findItems = chat.contactList.filter(e => e.contact_id === contactId);
        const chatType = (findItems.length > 0) ? findItems[0].chat_type : null;

        xmppClient.sendMessage(messageBuilder({
            from: xmppClient.getIdToJid(chat.profile.contactId),
            to: xmppClient.getIdToJid(contactId, (chatType !== "single")),
            chatType, body
        }));

        return { ...action, contactId, body };
    }

    const messageBuilder = message => {
        if (message.body.attachments && Array.isArray(message.body.attachments)) {
            message.body.attachments.forEach(e => {
                if (!e.id) e.id = moment.utc().valueOf();
            });
        }

        return {
            from: message.from, to: message.to,
            chatType: message.chatType,
            ...message.authorId ? { authorId: message.authorId } : {},
            ...message.messageType ? { messageType: message.messageType } : {},
            body: {
                id: message.body.id, ts: message.body.ts, contentType: message.body.contentType, content: message.body.content,
                subname: message.body.subname ? message.body.subname : null,
                ...message.body.attachments ? { attachments: message.body.attachments } : {}
            }
        };
    }

    return next => action => {
        switch (action.type) {
            case CONNECT_XMPP:
                action = { ...action, ...xmppConnect(action) };
                break;
            case CONNECTED_XMPP:
                xmppConnected();
                break;
            case CHAT_CONTACT_LIST:
                action = { ...action, contactList: joinIntoContact(action.contactList) };
                break;
            case SEND_MESSAGE_TO_XMPP:
                action = { ...action, ...sendMessage(action) };
                break;
            case FILE_UPLOADING:
                action = { ...action, ...fileUploading(action) };
                break;
            case FILE_UPLOADED_ON_SUCCESS:
                action = { ...action, ...fileUploaded(action) };
                break;
            case DISCONNECT_XMPP:
                if (xmppClient) xmppClient.disconnect();
                break;
            case LOGOUT:
                if (xmppClient) xmppClient.disconnect();
                break;
            default:
                break;
        }

        return next(action);
    };
};

export default xmppMiddleware;